import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactForm.css';

const ContactForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    companyName: '',
    companyWebsite: '',
    companySize: '',
    annualRevenue: '',
    projectBudget: '',
    services: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('Sending...');

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const userTemplateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_USER;
    const adminTemplateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_ADMIN;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    // Create promises for both emails
    const sendUserEmail = emailjs.send(serviceID, userTemplateID, formData, publicKey);
    const sendAdminEmail = emailjs.send(serviceID, adminTemplateID, formData, publicKey);

    Promise.all([sendUserEmail, sendAdminEmail])
      .then(([userResponse, adminResponse]) => {
        console.log('User email SUCCESS!', userResponse.status, userResponse.text);
        console.log('Admin email SUCCESS!', adminResponse.status, adminResponse.text);
        setSubmitMessage('Your message has been sent successfully!');
        setFormData({
            name: '', email: '', role: '', companyName: '', companyWebsite: '', 
            companySize: '', annualRevenue: '', projectBudget: '', services: '', message: '',
        });
        setTimeout(() => {
          if (onSuccess) onSuccess(formData.name, formData.email);
        }, 2000);
      }, (err) => {
        console.log('FAILED...', err);
        setSubmitMessage('Failed to send message. Please try again.');
      })
      .finally(() => {
          setIsSubmitting(false);
      });
  };

  return (
    <div className="contact-form-container">
      <h2>Tell us where you're at</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-grid">
          <input type="text" name="name" placeholder="What is your name?" value={formData.name} onChange={handleChange} required />
          <input type="email" name="email" placeholder="What is your email?" value={formData.email} onChange={handleChange} required />
          <input type="text" name="role" placeholder="What is your role in the company?" value={formData.role} onChange={handleChange} />
          <input type="text" name="companyName" placeholder="Company Name" value={formData.companyName} onChange={handleChange} />
          <input type="text" name="companyWebsite" placeholder="Company Website" value={formData.companyWebsite} onChange={handleChange} />
          
          <select name="companySize" value={formData.companySize} onChange={handleChange}>
            <option value="">Select company size</option>
            <option value="<20">Less than 20</option>
            <option value="20-50">20-50</option>
            <option value="50-100">50-100</option>
            <option value="100-500">100-500</option>
            <option value=">500">More than 500</option>
          </select>

          <select name="annualRevenue" value={formData.annualRevenue} onChange={handleChange}>
            <option value="">Select revenue range</option>
            <option value="<100K">Less than $100K</option>
            <option value="100K-500K">$100K-$500K</option>
            <option value="500K-1M">$500K-$1M</option>
            <option value="1M-2M">$1M-$2M</option>
            <option value=">2M">More than $2M</option>
          </select>

          <select name="projectBudget" value={formData.projectBudget} onChange={handleChange}>
            <option value="">Select budget range</option>
            <option value="<10K">Less than $10K</option>
            <option value="10K-50K">$10K-$50K</option>
            <option value="50K-100K">$50K-$100K</option>
            <option value=">100K">More than $100K</option>
          </select>

          <select name="services" value={formData.services} onChange={handleChange}>
            <option value="">What services are you interested in?</option>
            <option value="identify">Identifying AI opportunities</option>
            <option value="educate">Educating your team on AI</option>
            <option value="develop">Developing custom AI solutions</option>
          </select>
        </div>
        
        <textarea name="message" placeholder="Message" value={formData.message} onChange={handleChange}></textarea>
        <button type="submit" className="cta-button" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Send inquiry'}
        </button>
        {submitMessage && <p className="submit-message">{submitMessage}</p>}
      </form>
    </div>
  );
};

export default ContactForm; 